// Lógica para la navegación secuencial en el menú móvil
document.addEventListener('turbolinks:load', () => {
  initMobileMenu();
  
  // Reiniciar menú cuando se cierra el navbar
  const navbarToggler = document.getElementById('navbarToggler');
  if (navbarToggler) {
    navbarToggler.addEventListener('click', function() {
      // Si el navbar está cerrado (se va a abrir), no hacemos nada
      if (!document.querySelector('.navbar-collapse').classList.contains('show')) {
        return;
      }
      
      // Si se va a cerrar, esperamos un poco y reiniciamos el menú
      setTimeout(() => {
        resetMobileMenu();
      }, 300);
    });
  }
});

function initMobileMenu() {
  // Ocultamos todos los submenús al inicio, excepto el menú principal
  const menuChildren = document.querySelectorAll('.mobile-menu-child');
  menuChildren.forEach(menu => {
    menu.classList.remove('active');
  });
  
  // Aseguramos que el menú principal está visible
  const mainMenu = document.getElementById('mobile-menu-main');
  if (mainMenu) {
    mainMenu.classList.add('active');
  }

  // Manejamos los clicks en elementos del menú para navegación hacia adelante
  const menuItems = document.querySelectorAll('.mobile-menu-item[data-target]');
  menuItems.forEach(item => {
    item.addEventListener('click', function(event) {
      if (event.target.tagName === 'A' && event.target.getAttribute('href')) {
        // Si es un enlace con href, permitimos la navegación normal
        return;
      }
      
      // Prevenimos la navegación por defecto para los elementos de navegación secuencial
      event.preventDefault();
      
      const targetId = this.getAttribute('data-target');
      const targetMenu = document.getElementById(targetId);
      
      if (targetMenu) {
        // Oculta el menú actual
        const parentMenu = this.closest('.nav-item-mobile');
        if (parentMenu) {
          parentMenu.classList.remove('active');
        }
        
        // Muestra el menú destino
        targetMenu.classList.add('active');
      }
    });
  });

  // Manejamos los clicks en botones de regresar
  const backButtons = document.querySelectorAll('.mobile-menu-back');
  backButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      const parentMenuId = this.getAttribute('data-parent');
      const parentMenu = document.getElementById(parentMenuId);
      
      if (parentMenu) {
        // Oculta el menú actual
        const currentMenu = this.closest('.nav-item-mobile');
        if (currentMenu) {
          currentMenu.classList.remove('active');
        }
        
        // Muestra el menú padre
        parentMenu.classList.add('active');
      }
    });
  });
  
  // Cerrar el menú móvil al hacer clic en un enlace de tour
  const tourLinks = document.querySelectorAll('.mobile-menu-child .nav-link[href]');
  tourLinks.forEach(link => {
    link.addEventListener('click', function() {
      const navbarCollapse = document.querySelector('.navbar-collapse');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const bsCollapse = new bootstrap.Collapse(navbarCollapse);
        bsCollapse.hide();
      }
    });
  });

  // Limpiar la navegación cuando se cierra el menú móvil
  const navbarCollapse = document.getElementById('navbarSupportedContent');
  if (navbarCollapse) {
    navbarCollapse.addEventListener('hidden.bs.collapse', function () {
      // Volver al menú principal cuando se cierra el menú móvil
      menuChildren.forEach(menu => {
        menu.classList.remove('active');
      });
      
      if (mainMenu) {
        mainMenu.classList.add('active');
      }
    });
  }
}
